import request from '@/utils/request-wechat'

// 微信登录二维码
export function loginQRCode () {
  return request({
    url: '/getMpQrCode',
    method: 'GET',
    
  })
}
// 获取微信扫码状态
export function scanCode (id) {
  return request({
    url: `/getScanResult?id=${id}`,
    method: 'GET',
    
  })
}
// 微信绑定二维码
export function bindCode () {
  return request({
    url: '/getBindQrCode',
    method: 'GET',
    
  })
}



